import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import draftsEn from './locales/en/drafts.json'
import draftsDe from './locales/de/drafts.json'

// Scoped to the Drafts feature for now - other parts of the app don't go
// through this instance.
export const SUPPORTED_LOCALES = ['en', 'de']
export const DEFAULT_LOCALE = 'en'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { drafts: draftsEn },
      de: { drafts: draftsDe },
    },
    lng: DEFAULT_LOCALE,
    fallbackLng: DEFAULT_LOCALE,
    ns: ['drafts'],
    defaultNS: 'drafts',
    interpolation: { escapeValue: false }, // React already escapes
    react: { useSuspense: false },
  })

export default i18n
